
import { Vue, Options } from "vue-class-component";

export default class CardComponent extends Vue {}
